const supportedChatroomListTypes = {
  all: 1,
  groups: 1,
  unread: 1,
};

export type ChatroomListType = keyof typeof supportedChatroomListTypes;

export const isChatroomListType = (value?: unknown): value is ChatroomListType =>
  typeof value === 'string' ? value in supportedChatroomListTypes : false;
